const e = {
  name: "Codec",
  dimensions: { width: 28, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 40" style="enable-background:new 0 0 28 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10.8,19.3l9.5,5.7v2l-9.5,5.7l-1.8-1V20.3L10.8,19.3z M11,21.8v8.5l7.1-4.2L11,21.8z"/>
		<path class="st0" d="M0,3c0-1.7,1.3-3,3-3h13.4L28,11.6V37c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3z M3,2C2.5,2,2,2.5,2,3v34
			c0,0.5,0.5,1,1,1h22c0.5,0,1-0.5,1-1V14h-8.8c-1.8,0-3.2-1.4-3.2-3.2V2H3z M16,2.4v8.4c0,0.6,0.5,1.2,1.2,1.2h8.4L16,2.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Codec
};
